import React, { useState } from 'react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { FaStar, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';

/**
 * StarRating — display or input of a 1..5 star rating.
 *
 * Display mode (default): supports halves, e.g. value={4.5}.
 * Input mode: pass onChange; stars become clickable with hover preview.
 */
const StarRating = ({ value = 0, onChange, size = 4, showValue = false, color = 'yellow.400' }) => {
  const [hovered, setHovered] = useState(0);
  const isInput = typeof onChange === 'function';
  const shown = isInput && hovered > 0 ? hovered : value;

  const starFor = (i) => {
    if (shown >= i) return FaStar;
    if (!isInput && shown >= i - 0.5) return FaStarHalfAlt;
    return FaRegStar;
  };

  return (
    <HStack spacing={0.5} display="inline-flex" align="center">
      {[1, 2, 3, 4, 5].map((i) => (
        <Icon
          key={i}
          as={starFor(i)}
          boxSize={size}
          color={color}
          cursor={isInput ? 'pointer' : 'default'}
          onClick={isInput ? () => onChange(i) : undefined}
          onMouseEnter={isInput ? () => setHovered(i) : undefined}
          onMouseLeave={isInput ? () => setHovered(0) : undefined}
          aria-label={`${i} star${i > 1 ? 's' : ''}`}
        />
      ))}
      {showValue && (
        <Text as="span" fontSize="sm" ml={1.5} color="gray.600">
          {Number(value || 0).toFixed(1)}
        </Text>
      )}
    </HStack>
  );
};

export default StarRating;
